<template>
  <div class="SectorsCovered">
    <div class="main-section">
      <div class="title">Sectors Covered</div>

      <div class="marquee-container">
        <!-- First Marquee (Right to Left) -->
        <div class="marquee-wrapper" @mouseover="pauseMarquee" @mouseleave="resumeMarquee">
          <div class="marquee-content">
            <div class="sector-card" v-for="(sector, index) in [...sectors, ...sectors]" :key="'first-' + index">
              <img :src="sector.logo" alt="" />
              <div class="sector-name">{{ sector.sector }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="marquee-container">
        <!-- Second Marquee (Left to Right) -->
        <div class="marquee-wrapper reverse" @mouseover="pauseMarquee" @mouseleave="resumeMarquee">
          <div class="marquee-content">
            <div class="sector-card" v-for="(sector, index) in [...sectors, ...sectors]" :key="'second-' + index">
              <img :src="sector.logo" alt="" />
              <div class="sector-name">{{ sector.sector }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { serverAddr, serverHostName } from '../networkConfig';

export default {
  name: 'SectorsCovered',
  data() {
    return {
      sectors: [],
      serverHostName: serverHostName,
    };
  },
  created() {
    this.getSectors();
  },
  methods: {
    getSectors() {
      serverAddr
        .get('/recommendation/v1/stock_sector_list')
        .then((response) => {
          if (response.data.status) {
            this.sectors = response.data.data;
          } else {
            console.error('Failed to fetch sector data');
          }
        })
        .catch((error) => {
          console.error('Error fetching sector data:', error);
        });
    },
    pauseMarquee(event) {
      event.currentTarget.style.animationPlayState = 'paused';
    },
    resumeMarquee(event) {
      event.currentTarget.style.animationPlayState = 'running';
    },
  },
};
</script>

<style scoped lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';
.SectorsCovered {
  text-align: center;
  width: 100%;
  margin-bottom: 60px;

  .main-section {
    .title {
      font-size: 25px;
      font-weight: 700;
      margin-top: 40px;
      margin-bottom: 30px;
    }

    .marquee-container {
      overflow: hidden;
      white-space: nowrap;
      margin-bottom: 15px;
      position: relative;
      width: 100%;
    }

    .marquee-wrapper {
      display: flex;
      white-space: nowrap;
      width: max-content;
      animation: marquee 40s linear infinite;
    }

    .reverse {
      animation: marquee-reverse 45s linear infinite;
    }

    .marquee-wrapper:hover {
      animation-play-state: paused;
    }

    .marquee-content {
      display: flex;
      align-items: center;
      gap: 10px;
      white-space: nowrap;
    }

    .sector-card {
      display: flex;
      align-items: center;
      background-color: #fff;
      padding: 5px 15px 5px 5px;
      border-radius: 30px;
      box-shadow: 1px 2px 7px 0px #d9d5d5;
      white-space: nowrap;
      margin-right: 10px;
    }

    .sector-name {
      font-size: 12px;
      font-weight: 600;
      margin-left: 5px;
    }

    img {
      width: 38px;
      height: 38px;
    }
  }
}

@keyframes marquee {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

@keyframes marquee-reverse {
  from {
    transform: translateX(-50%);
  }
  to {
    transform: translateX(0);
  }
}
</style>
